export const UPDATE_FEED_ENTRY_PROPS = 'UPDATE_FEED_ENTRY_PROPS';
// Registers any changes made to the comment form on feed card entries
export const REGISTER_FEED_ENTRY_UI_CHANGE = 'REGISTER_FEED_ENTRY_UI_CHANGE';
export const UPDATE_RITMO_REGISTERED_IMPRESSIONS =
  'UPDATE_RITMO_REGISTERED_IMPRESSIONS';
export const UPDATE_NUM_ENTRIES = 'UPDATE_LAST_ENTITY_TO_ENTER';
export const UPDATE_IS_RESTORING_SCROLL_POSITION =
  'UPDATE_IS_RESTORING_SCROLL_POSITION';

export default {
  UPDATE_FEED_ENTRY_PROPS,
  REGISTER_FEED_ENTRY_UI_CHANGE,
  UPDATE_RITMO_REGISTERED_IMPRESSIONS,
  UPDATE_NUM_ENTRIES,
  UPDATE_IS_RESTORING_SCROLL_POSITION
};
